/*******************************************************************************
 * Copyright (c) 2025 Bula Technologies
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 1.0.0
 *
 *******************************************************************************/

 
import { Container } from '@mui/material';


const TosPage = () => {

    return (
        <Container maxWidth="md">
            <div id="features" class="white-section connection-section wf-section">
                <div class="container-4 w-container">
                  
                </div>
            </div>
        </Container>
    )

}

export default TosPage;
